import { AxiosInstance } from 'axios';
import { Status, CreateStatusRequest, UpdateStatusRequest } from '../types';

/**
 * Status API endpoints
 * Platform-agnostic - works with any HTTP client
 */
export class StatusesApi {
  constructor(private client: AxiosInstance) {}

  /**
   * Get all statuses for a board
   */
  async getStatuses(boardId: string): Promise<Status[]> {
    const response = await this.client.get<Status[]>(`/api/boards/${boardId}/statuses`);
    return response.data;
  }

  /**
   * Create a new status
   */
  async createStatus(boardId: string, request: CreateStatusRequest, hubConnectionId?: string): Promise<Status> {
    const url = hubConnectionId
      ? `/api/boards/${boardId}/statuses?hubConnectionId=${encodeURIComponent(hubConnectionId)}`
      : `/api/boards/${boardId}/statuses`;
    const response = await this.client.post<Status>(url, request);
    return response.data;
  }

  /**
   * Update an existing status
   */
  async updateStatus(boardId: string, statusId: string, request: UpdateStatusRequest, hubConnectionId?: string): Promise<Status> {
    const url = hubConnectionId
      ? `/api/boards/${boardId}/statuses/${statusId}?hubConnectionId=${encodeURIComponent(hubConnectionId)}`
      : `/api/boards/${boardId}/statuses/${statusId}`;
    // The controller validates that the body's id and boardId match the route params.
    const response = await this.client.put<Status>(url, { ...request, id: statusId, boardId });
    return response.data;
  }

  /**
   * Delete a status
   */
  async deleteStatus(boardId: string, statusId: string, hubConnectionId?: string): Promise<void> {
    const url = hubConnectionId
      ? `/api/boards/${boardId}/statuses/${statusId}?hubConnectionId=${encodeURIComponent(hubConnectionId)}`
      : `/api/boards/${boardId}/statuses/${statusId}`;
    await this.client.delete(url);
  }

  /**
   * Reorder statuses
   */
  async reorderStatuses(boardId: string, statusIds: string[], hubConnectionId?: string): Promise<void> {
    const url = hubConnectionId
      ? `/api/boards/${boardId}/statuses?hubConnectionId=${encodeURIComponent(hubConnectionId)}`
      : `/api/boards/${boardId}/statuses`;
    await this.client.put(url, statusIds);
  }
}
